// Price Filter
export const MINMAX = 'minmax'

// Collection Filter
export const SALES = 'sales'
export const NO_SALES = 'no_sales'
